module.exports = {"items":[{"title":"Home","link":"/"},{"title":"GitHub","link":"https://github.com/learnpack"}]}